/***********************************************************************************
 * StoreCodeInput Component
 * A vue component allow user to type store code
 *
 * @author Zip Co - Plugin Team
 *
 ***********************************************************************************/

import { Component, Vue, Emit } from 'vue-property-decorator';

@Component({
    components: {}
})
class StoreCodeInput extends Vue {
    private readonly maxValue: number = 9;
    private readonly minValue: number = 0;

    private readonly lengthOfStoreCode: number = 6;
    private storeCode = new Array<number | undefined>(this.lengthOfStoreCode);
    private activeCodeSlot: number = 0;
    private readonly storeCodeMask = '#';
    private readonly keyboardEnabled = false;

    // the keys used as keypad
    private keys = [[1, 2, 3], [4, 5, 6], [7, 8, 9], ['close', 0, 'backspace']];

    private get isTouchDevice(): boolean {
        return ('ontouchstart' in window);
    }

    /**
     * handle any key been pressed in the key pad
     * @param key the key pressed from key pad
     */
    public pressKey(key: any): void {
        if (!isNaN(key)) {
            this.storeCode[this.activeCodeSlot++] = Number.parseInt(key);
        } else {
            switch (key) {
                case 'close':
                    this.storeCode = new Array<number | undefined>(this.lengthOfStoreCode);
                    this.activeCodeSlot = 0;
                    break;
                case 'backspace':
                    this.storeCode[this.activeCodeSlot > 0 ? --this.activeCodeSlot : this.activeCodeSlot] = undefined;
                    break;
            }
        }

        this.next();
    }

    /**
     * handle next step, move to next code slot or trigger storeCodeEntered event
     */
    private next(): void {
        if (this.activeCodeSlot < this.lengthOfStoreCode) {
            ((this.$refs[`storeCode_${this.activeCodeSlot}`] as HTMLElement[])[0] as HTMLElement).focus();
        } else {
            this.activeCodeSlot--;
            ((this.$refs[`storeCode_${this.activeCodeSlot - 1}`] as HTMLElement[])[0] as HTMLElement).blur();
            setTimeout(this.getStoreCode, 200);
        }
    }

    /**
     * when store code input been changes, set active slot to be the next one and go to next step
     * @param index the index of current input slot
     * @param value the value been typed
     */
    public onStoreCodeInput(index: number, value: string): void {
        if (!isNaN(Number.parseInt(value))) {
            this.activeCodeSlot = ++index;
            this.next();
        }
    }

    /**
     * Return store code when storeCodeEntered event been triggered
     */
    @Emit('storeCodeEntered')
    private getStoreCode(): string {
        const code = this.storeCode.join('');
        this.reset();
        return code;
    }

    /**
     * reset store code slots
     */
    private reset(): void {
        this.storeCode = new Array<number | undefined>(this.lengthOfStoreCode);
        this.activeCodeSlot = 0;
    }
}

export default StoreCodeInput;
